export default __webpack_public_path__ + "assets/images/Alert-f91f0d6eb6ab6bf366aae45677532e20.svg";